import * as React from "react";
import call from "../../call";
import { observer } from "mobx-react";
import {
  ModalEnum,
  ModalStoreContext,
  DownloadResultsModalStoreContext,
} from "../../store";
import axios from "axios";
import downloadBlob from "../../download";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";

const MODAL_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CHIP_ITEM_HEIGHT = 48;
const CHIP_ITEM_PADDING_TOP = 8;
const CHIP_MENU_PROPS = {
  PaperProps: {
    style: {
      maxHeight: CHIP_ITEM_HEIGHT * 4.5 + CHIP_ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const DownloadResultsModal = observer(() => {
  const modalStore = React.useContext(ModalStoreContext);
  const downloadResultsModalStore = React.useContext(
    DownloadResultsModalStoreContext,
  );

  const handleSelectedBuyingStagesChange = (event) => {
    const {
      target: { value },
    } = event;
    downloadResultsModalStore.setSelectedBuyingStages(value);
  };

  const handleDownloadClick = (event) => {
    if (downloadResultsModalStore.selectedBuyingStages.length == 0) {
      downloadResultsModalStore.setError("No buying stages selected!");
      return;
    }

    downloadResultsModalStore.setError("");
    call(
      axios({
        method: "get",
        url: "/api/g2/task",
        headers: {
          "content-type": "application/json",
          accept: "application/zip",
        },
        params: {
          task_id: downloadResultsModalStore.taskId,
          buying_stages: downloadResultsModalStore.selectedBuyingStages,
        },
        responseType: "blob",
      }),
    )
      .then((resp) => {
        downloadBlob("Segments.zip", resp.data);
        downloadResultsModalStore.setError("");
        downloadResultsModalStore.setLoading(false);
        modalStore.setModal(ModalEnum.NONE);
      })
      .catch((error) => {
        downloadResultsModalStore.setError(error.response.data.error);
        downloadResultsModalStore.setLoading(false);
      });

    downloadResultsModalStore.setLoading(true);
  };

  return (
    <div>
      <Modal
        open={true}
        onClose={() => modalStore.setModal(ModalEnum.NONE)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={MODAL_STYLE}>
          <Stack sx={{ width: "100%" }} spacing={2}>
            {downloadResultsModalStore.error.length > 0 ? (
              <Alert severity="error">{downloadResultsModalStore.error}</Alert>
            ) : (
              ""
            )}
            <FormControl sx={{ width: "100%" }}>
              <InputLabel id="buying-stages-chip-label">
                Buying Stages
              </InputLabel>
              <Select
                labelId="buying-stages-chip-label"
                id="buying-stages-chip"
                multiple
                value={downloadResultsModalStore.selectedBuyingStages}
                onChange={handleSelectedBuyingStagesChange}
                input={
                  <OutlinedInput
                    id="buying-stages-multiple-chip"
                    label="Buying Stages"
                  />
                }
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((stage) => (
                      <Chip key={stage} label={stage} />
                    ))}
                  </Box>
                )}
                MenuProps={CHIP_MENU_PROPS}
              >
                {downloadResultsModalStore.buyingStages.map((stage) => (
                  <MenuItem key={stage} value={stage}>
                    {stage}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ width: "100%" }}>
              <LoadingButton
                loading={downloadResultsModalStore.isLoading}
                variant="contained"
                onClick={handleDownloadClick}
              >
                Download
              </LoadingButton>
            </FormControl>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
});

export default DownloadResultsModal;
